<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2L14 14M2 14L14 2"
      stroke="var(--icon-border-default)"
      stroke-width="1.1"
    />
  </svg>
</template>
